var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
    fill: "url(#paint0_linear_18427_9577)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24334 15.8312C11.9077 13.799 15.0179 12.4593 16.5742 11.812C21.0176 9.96384 21.9409 9.64279 22.5426 9.63219C22.675 9.62986 22.9709 9.66266 23.1626 9.81821C23.3245 9.94956 23.369 10.127 23.3904 10.2515C23.4117 10.376 23.4382 10.6597 23.4171 10.8814C23.1763 13.4114 22.1344 19.5509 21.6044 22.3846C21.3801 23.5836 20.9385 23.9856 20.5109 24.0249C19.5818 24.1104 18.8762 23.4109 17.9763 22.821C16.5681 21.8979 15.7725 21.3232 14.4056 20.4225C12.8259 19.3815 13.85 18.8093 14.7503 17.8743C14.9859 17.6296 19.0797 13.9059 19.159 13.5681C19.1689 13.5258 19.1781 13.3684 19.0845 13.2852C18.991 13.2021 18.8529 13.2305 18.7532 13.2531C18.612 13.2852 16.3624 14.7721 12.0043 17.7139C11.3658 18.1523 10.7874 18.366 10.2692 18.3548C9.69792 18.3424 8.599 18.0318 7.78206 17.7662C6.78006 17.4405 5.98369 17.2683 6.05304 16.7152C6.08916 16.427 6.48592 16.1324 7.24334 15.8312Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18427_9577",
    x1: 16,
    y1: 0,
    x2: 16,
    y2: 31.7627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.98fc2b1619ffdc7d45f015db8cd11797.svg";
export { ForwardRef as ReactComponent };